import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const TermsContent = dynamic(() => import('../components/static/terms'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';

function Terms(props) {
	const meta = {
		title: "Bayan terms of use | Bayan",
		description: "BAYAN TERMS OF USE - PROPOSED. Effective Date: 7/1/2020. Welcome to bayanclaremont.org and bayanonline.org, which are owned and operated by Bayan, Inc. (referred to as “BAYAN,” “the Institute,” “We,” or “Us”) of Orange, California in the United States of America.",
		route: "terms-of-service",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<TermsContent router={props.router} />
			</Layout>
		</>
	);
}

export default withRouter(Terms);
